/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_History_Task_PrefixInputs */

const en_case_history_task_prefix = /** @type {(inputs: Case_History_Task_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Task`)
};

const pt_br2_case_history_task_prefix = /** @type {(inputs: Case_History_Task_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarefa`)
};

/**
* | output |
* | --- |
* | "Task" |
*
* @param {Case_History_Task_PrefixInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_history_task_prefix = /** @type {((inputs?: Case_History_Task_PrefixInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_History_Task_PrefixInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_history_task_prefix(inputs)
	return pt_br2_case_history_task_prefix(inputs)
});